import React, { Suspense } from "react";

import { ClientOnly } from "@/utils/client-only";

import {
    GlobalFooterFallback,
    type GlobalFooterPatternProps
} from "./global-footer";

// @ts-ignore
const Footer = React.lazy(() => import("./global-footer"));

export const GlobalFooter = (props: GlobalFooterPatternProps) => (
    <Suspense fallback={<GlobalFooterFallback />}>
        <ClientOnly>
            <Footer {...props} />
        </ClientOnly>
    </Suspense>
);
